// ... existing code ...

const ServiceCards = () => {
  const services = [
    {
      icon: 'ri-home-gear-line',
      title: 'Complete Roof Replacement',
      description: 'Full roof replacement with premium materials and expert installation. We handle everything from tear-off to final inspection.',
      features: ['25-50 year warranties', 'Premium shingle options', 'Complete tear-off included', 'Final inspection & cleanup'],
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/8aca30e0cdad4296017ee1c1bb1ffe00.jpeg'
    },
    {
      icon: 'ri-tools-line',
      title: 'Roof Repair & Maintenance',
      description: 'Expert repairs for leaks, storm damage, and wear. Fast response times and quality workmanship to extend your roof\'s life.',
      features: ['Emergency repairs available', 'Leak detection & repair', 'Storm damage assessment', 'Preventive maintenance'],
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/d732e640ab8d43838816ef12678313ea.jpeg'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Insurance Claim Assistance',
      description: 'We work directly with your insurance company to ensure you get the coverage you deserve. No stress, no hassle.',
      features: ['Free damage inspection', 'Documentation assistance', 'Direct insurance billing', 'Claims advocacy'],
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/580a8ff45e7bb92d76543b971a386255.jpeg'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Roof Inspection',
      description: 'Comprehensive roof inspections with detailed reports. Perfect for home buyers, sellers, or routine maintenance.',
      features: ['Detailed photo reports', 'Drone inspections available', 'Written recommendations', 'Same-day scheduling'],
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/0230ca8e0928ce184862cbfd18cbc5c3.jpeg'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Emergency Services',
      description: '24/7 emergency response for urgent roofing issues. We\'re here when you need us most.',
      features: ['24/7 availability', 'Rapid response time', 'Temporary repairs', 'Storm damage specialists'],
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/f6dccf425d8a1fffa9020eaa2d77957c.jpeg'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Gutter Services',
      description: 'Complete gutter installation, repair, and maintenance to protect your home\'s foundation and landscaping.',
      features: ['Seamless gutter installation', 'Gutter guard systems', 'Repair & replacement', 'Cleaning & maintenance'],
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/f22a37a2ec66390a046104b72da39436.jpeg'
    }
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 font-['Poppins']">
            Our Services
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Comprehensive roofing solutions tailored to your needs
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="relative h-48 sm:h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#4A90E2] rounded-xl">
                  <i className={`${service.icon} text-2xl sm:text-3xl text-white`}></i>
                </div>
              </div>

              <div className="p-6 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 font-['Poppins']">
                  {service.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
                  {service.description}
                </p>

                <ul className="space-y-2 sm:space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-sm sm:text-base">
                      <i className="ri-check-line text-[#4A90E2] mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="/contact"
                  className="block w-full text-center bg-[#2B5BA6] text-white py-3 rounded-lg font-semibold hover:bg-[#234a8a] transition-colors whitespace-nowrap cursor-pointer min-h-[48px] flex items-center justify-center"
                >
                  Learn More
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;
